/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TransactionStatusResponseItem } from './transaction-status-response-item';
import { TransactionTypeInfoResponseItem } from './transaction-type-info-response-item';


export interface SearchTransactionsResponseItem { 
    id: string;
    currencyName: string;
    currencyTicker: string;
    chainCode: string;
    chainName: string;
    accountName: string;
    amount: number;
    commission?: number | null;
    type: TransactionTypeInfoResponseItem;
    status: TransactionStatusResponseItem;
    createdDate: string;
    rejectReason: string;
}

